module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {},
    on: {
      "click": _vm.previousTruckView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Vehicle No:- " + _vm._s(_vm.VehicleNo))])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h3', [_vm._v("Location :- " + _vm._s(_vm.description))])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h3', [_vm._v("Latitude :- " + _vm._s(_vm.latlong.lat))])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h3', [_vm._v("Longitude :- " + _vm._s(_vm.latlong.lng))])])], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "5%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "700px",
      "height": "500px"
    },
    attrs: {
      "center": _vm.latlong,
      "zoom": 15,
      "map-type-id": "hybrid"
    }
  }, [_c('GmapMarker', {
    ref: "myMarker",
    attrs: {
      "position": _vm.google && new _vm.google.maps.LatLng(_vm.latlong.lat, _vm.latlong.lng),
      "clickable": true,
      "draggable": true
    },
    on: {
      "click": function($event) {
        _vm.center = _vm.m.position
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579761ab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleMaster/map.vue
// module id = 2652
// module chunks = 0